module.exports = __webpack_public_path__ + "static/media/locbanner.53327acb.svg";